<template>
  <v-data-table
    :headers="headers"
    :items="getItems"
    :search="search"
    sort-by="nombre"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar..."
          single-line
          hide-details
        ></v-text-field>
        <v-btn color="green" small outlined @click="descargarExcel"><v-icon color="green">mdi-microsoft-excel</v-icon></v-btn>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
              >NUEVO</v-btn
            >
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      v-model="editedItem.codigo"
                      label="Codigo Cliente *"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      v-model="editedItem.nit"
                      label="Nit *"
                      @change="findClienteSat"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.nombre"
                      label="Nombre *"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.direccion"
                      label="Direccion *"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      v-model="editedItem.telefono"
                      label="Telefono"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="8" md="8">
                    <v-text-field
                      v-model="editedItem.email"
                      label="Correo"
                    ></v-text-field>
                  </v-col>
                  <!--                   
                  <v-col cols="12">
                    <v-switch
                      v-model="editedItem.condicion"
                      :label="editedItem.condicion ==1 ? 'Activado' :'Desactivado'"
                      color="green"
                      :value="editedItem.condicion ==1 ? editedItem.condicion=1 : editedItem.condicion=0"
                      hide-details                   
                    ></v-switch>              
                  </v-col>   
                  -->
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small  class="mr-2"  @click="editItem(item)" >
        mdi-pencil
      </v-icon>
      <v-icon small @click="deleteItem(item)">
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Recargar</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import findClienteSat from './utils/find.cliente'
import {json2excel} from 'js2excel';

export default {
  data: () => ({
    title: "CLIENTES",
    search: "",
    estado: false,
    dialog: false,
    headers: [
      { text: "Codigo", align: "center", value: "codigo" },
      { text: "Nit", align: "center", value: "nit" },
      { text: "Nombre", value: "nombre",width: '25%' },
      { text: "Direccion", value: "direccion",width: '40%'  },
      { text: "Telefono", align: "center", value: "telefono" },
      { text: "Correo", align: "center", value: "email" },
      { text: "Estado", align: "center", value: "estado" },
      { text: "Actions", align: "center", value: "actions", sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      codigo:'CC-001',
      nombre: "",
      nit: "",
      direccion: "",
      email: "",
      telefono: "",
    },
    defaultItem: {
      codigo:'CC-001',
      nombre: "",
      nit: "",
      direccion: "",
      email: "",
      telefono: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Registro" : "Editar Registro";
    },
    getItems(){
        return this.$store.getters.getAllClientes
    },
    getTokenUser(){
      return this.$store.getters.getTokenUser
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  async created() {
   await this.initialize();
  },

  methods: {
    async initialize() {
      await this.$store.dispatch('setClientes')       
    },
    editItem(item) {
      this.editedIndex = this.getItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    async findClienteSat(){
      this.editedItem.nit = this.editedItem.nit.replace(/-/, '')
      if(this.editedIndex<0){
      const cliente = await findClienteSat(this.editedItem.nit) 
      this.editedItem.nombre = cliente
      }
    
    },
    deleteItem(item) {
      Swal.fire({
        title: "Esta Seguro?",
        text: "El registro será ELIMINADO!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, Eliminar!",
        cancelButtonText: "Cancelar!",
      }).then((result) => {
        if (result.isConfirmed) {
           item.estado = "Eliminado"
           this.editedItem = Object.assign({}, item)
           this.putItem()
        }
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (this.editedIndex > -1) {
        await this.putItem();
      } else {
        await this.postItem();
      }
      await this.initialize(); 
      this.close();
    },
    async postItem() {
      await this.$store.dispatch('createCliente',this.editedItem) 
    },
    async putItem() {
      try {
        await axios.put(`${this.$store.state.urlapi}/personas/${this.editedItem.idpersona}`,this.editedItem,this.getTokenUser)
        this.initialize()
        this.close()
        this.alertDone();
      } catch (error) {
        console.log(error)
         Swal.fire('Opps ocurrio un error','Error al procesar su solicitud','error')
      }
    },
    descargarExcel(){

        const data = this.getItems
        try {
            json2excel({
                data,
                name: 'Reporte_ClientesyProveedores',
                formateDate: 'yyyy/mm/dd'
            });
        } catch (e) {
            console.error('export error');
        }
      },
    //Notificaciones Swal
    alertDone() {
      Swal.fire({
        icon: "success",
        title: "Realizado",
        showConfirmButton: false,
        timer: 1500,
      });
    },
  },
};
</script>
